import React, { Component } from "react";
import RootOutfitUpload from "container/upload/RootOutfitUpload";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getEssentialUrl } from "lib/urlQueryParser";

class UploadOutfitPage extends Component {
  render() {
    return (
      <AppUpdateCheckpoint>
        <GatewayCheckpoint
          type={"replace"}
          url={getEssentialUrl({ type: "opening" })()}
        >
          <RootOutfitUpload />
        </GatewayCheckpoint>
      </AppUpdateCheckpoint>
    );
  }
}

export default UploadOutfitPage;
